import { IUserState } from './types';

export const initialState: IUserState = {
  billingUserType: 'natural',
  smartPackageRedesignAbGroup: 'control',
};
